<!-- Upload File Section -->
<div class="widget-container">
  <ion-grid>
    <ion-row class="close-row">
      <ion-col (click)="close()" class="close-col">
        <img src="../../../assets/icon/cancel.svg" alt="">
      </ion-col>
    </ion-row>
    <ion-row class="header-row">
      <ion-col>
        <div class="ion-text-start header-title">
          {{ 'Upload Documents'| translate }}
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="!isShowStepper">
      <div class="wrapper" style="width: 45%;">
        <ol class="c-stepper" style="margin-left: -7em">
          <li class="c-stepper__itemBox1">
            <ng-container>
              <div style="margin-top: 8px;
              padding-left: 14px">
                <span class="step_number">1</span>
              </div>
            </ng-container>
          </li>
          <li class="c-stepper__itemBox2">
            <ng-container>
              <div style="margin-top: 4px;
              padding-left: 10px">
                <span class="stepper-number">2</span>
              </div>
            </ng-container>
          </li>
        </ol>
      </div>
    </ion-row>
    <li class="c-stepper__item" *ngIf="!isShowStepper"></li>

    <!-- after Selection  -->
    <div *ngIf="isShowStepper">
      <ion-row>
        <div class="wrapper" style="width: 46%;">
          <ol class="c-stepper" style="margin-left: -6.2em">
            <li class="c-stepper__itemBox2" style="border: none !important;">
              <ng-container>
                <div class="stepper-done-img">
                  <ion-icon name="checkmark-circle-outline">
                  </ion-icon>
                </div>
              </ng-container>
            </li>
            <li class="c-stepper__itemBox1">
              <ng-container>
                <div style="margin-top: 8px;
              padding-left: 13px">
                  <span class="stepper-number">2</span>
                </div>
              </ng-container>
            </li>
          </ol>
        </div>
      </ion-row>
    </div>
    <li class="c-stepper__item"></li>
    <ion-row>
      <label class="c-stepper__title">{{ 'upload_select_type' | translate }}</label>
      <label class="c-stepper__title1">{{ 'upload_step_upload' | translate }}</label>
    </ion-row>

    <ion-row class="space"></ion-row>
    <div style="margin-left:1em" *ngIf="!isUploadEnable">
      <label class="libraryTitle">{{ 'upload_library_list_documents' | translate }}</label>
      <ion-row style="height: 5px;"></ion-row>
      <ng-select class="dropdown" [items]="libraryData" bindLabel="title" placeholder="{{'Select'|translate}}"
        [(ngModel)]="isShowButton" (change)="changeButtonEvent($event)">
      </ng-select>
    </div>

    <!-- Enable the Upload Options -->
    <div *ngIf="isUploadEnable">
      <div style="margin-left:1em">
        <label class="uploadTitle">{{ 'Add Library Files' | translate }}</label>
      </div>
      <ion-row style="height: 5px;"></ion-row>
      <div class="container">
        <div class="center">
          <input type="file" accept=".xls,.xlsx,.csv" class="custom-file-input"
            (change)="fileUpload($event);isDoneSubmit($event)" multiple="false"
            [(ngModel)]="isSubmitDone" />
          <div style="margin-top: -16%;
        margin-left: 34%;">
            <img style="width: 12px;
          height: 15px" src='../../../assets/icon/attach.svg' alt=""/>
            <ion-label class="labelTitle">
              {{'Attach File'|translate}}
            </ion-label>
          </div>
          <p class="textLabel">Or
          </p>
          <p class="textLabel1">{{ 'drag_and_drop' | translate }}</p>
        </div>
      </div>
      <label class="libraryTitle">{{ 'note_file_size_5mb_each' | translate }}</label>
    </div>
    <ion-row class="button-row" *ngIf="!Done">
      <button position="bottom" [disabled]="!isButtonEnable"
        [ngClass]="!isButtonEnable ? 'disable-button' : 'active-button'" (click)="onClickNext()">{{ 'Next' | translate }}</button>
    </ion-row>

    <ion-row class="button-row" *ngIf="Done">
      <!-- <button position="bottom" (click)="uploadFileToServer()">Done</button> -->
      <button position="bottom" [disabled]="!isDoneButtonEnable"
        [ngClass]="!isDoneButtonEnable ? 'disable-button' : 'active-button'"
        (click)="uploadFileToServer()">{{ 'Done' | translate }}</button>
    </ion-row>
  </ion-grid>
</div>